import React from 'react';

import { TWITCH_USERNAME } from '../consts';

export const TwitchChat = () => (
  // <div/>
  <iframe src={`//www.twitch.tv/embed/${TWITCH_USERNAME}/chat`}
    frameborder="0" scrolling="no" id="chat_embed" 
    width="350" style={{ height: '100%' }}
  />
);


// WEBPACK FOOTER //
// ./src/components/TwitchChat.js